var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.525 4.012v3.975H13.5a1.012 1.012 0 1 1 0 2.026H9.525v3.975a1.013 1.013 0 0 1-2.025 0v-3.976H3.525a1.013 1.013 0 0 1 0-2.024H7.5V4.011a1.013 1.013 0 0 1 2.025 0z",
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.ede912ea36adbb0a7f5abef221a46a6b.svg";
export { ForwardRef as ReactComponent };